// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"49":"component---src-pages-about-tsx","218":"component---src-pages-404-tsx","351":"commons","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"49":"ab030aeb36923295fa8e","218":"249d80a128e6f3fbf11f","351":"0cbfdba53a2d62b5b26b","691":"20530bc1c27dbb6f94b1"}[chunkId] + ".js";
};